import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayRoleModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/output/gateway-role.model';
import { CellContext } from '@tanstack/react-table';

export interface RoleListDescriptionCellProps
  extends CellContext<GatewayRoleModel, GatewayRoleModel['description']> {}

export const RoleListDescriptionCell = (
  props: RoleListDescriptionCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text truncate>{getValue()}</Text>;
};
